import React from 'react';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from './HelperText';

export default class DateOfBirthInput extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			icon,
			style,
			month,
			day,
			year,
			name,
			onChange,
			helperText,
			fieldErrors,
			readOnly = false
		} = this.props;

		return (
			<div className="row">
				<div className="col-sm-12">
					<div
						className="DateOfBirthInput"
						style={{ display: 'flex', justifyContent: 'space-between' }}
					>
						<div className="DateInput" style={{ width: '32%' }}>
							<span
								className={icon}
								style={{ fontSize: 16, top: 10, left: 13 }}
							/>
							<input
								type="text"
								autoCapitalize="off"
								className={icon ? 'has-icon' : ''}
								style={style}
								placeholder="MM"
								value={month || ''}
								onChange={(e) => onChange({ month: e.target.value, day, year })}
								readOnly={readOnly}
							/>
						</div>
						<div className="DateInput" style={{ width: '32%' }}>
							<input
								type="text"
								autoCapitalize="off"
								className={icon ? 'has-icon' : ''}
								style={style}
								placeholder="DD"
								value={day || ''}
								onChange={(e) => onChange({ month, day: e.target.value, year })}
								readOnly={readOnly}
							/>
						</div>
						<div className="DateInput" style={{ width: '32%' }}>
							<input
								type="text"
								autoCapitalize="off"
								className={icon ? 'has-icon' : ''}
								style={style}
								placeholder="YYYY"
								value={year || ''}
								onChange={(e) => onChange({ month, day, year: e.target.value })}
								readOnly={readOnly}
							/>
						</div>
					</div>
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : (
						<HelperText>{helperText}</HelperText>
					)}
				</div>
			</div>
		);
	}
}
